import {SvgIcon} from '@mui/material';
import React from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps{
    sx?:SxType
}

const PlayStopSvgIcon = ({sx}:IProps) => {
    return (
        <SvgIcon
        sx={sx}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                viewBox="0 0 18 18"
            >
                <path
                    fill="#FF7C84"
                    d="M5.666 12.334h6.667V5.667H5.666v6.667zm3.333 5a8.115 8.115 0 01-3.25-.657 8.415 8.415 0 01-2.645-1.78 8.416 8.416 0 01-1.782-2.647A8.114 8.114 0 01.666 9c0-1.152.219-2.236.656-3.25a8.416 8.416 0 011.782-2.646 8.415 8.415 0 012.645-1.78A8.115 8.115 0 019 .666c1.153 0 2.236.219 3.25.656a8.416 8.416 0 012.646 1.781 8.415 8.415 0 011.781 2.646A8.115 8.115 0 0117.333 9a8.115 8.115 0 01-.657 3.25 8.416 8.416 0 01-1.78 2.646 8.416 8.416 0 01-2.647 1.781 8.114 8.114 0 01-3.25.657zm0-1.667c1.861 0 3.438-.646 4.73-1.938 1.291-1.291 1.937-2.868 1.937-4.729 0-1.86-.646-3.437-1.938-4.729C12.438 2.98 10.861 2.334 9 2.334c-1.86 0-3.437.645-4.729 1.937C2.98 5.563 2.333 7.14 2.333 9.001c0 1.86.646 3.437 1.937 4.729C5.562 15.02 7.138 15.666 9 15.666z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default PlayStopSvgIcon;